import { useMutation } from "@tanstack/react-query";
import { addBenefits } from "app/api/benefit_api";

export const useAddBenefits = () => {
  return useMutation({ mutationFn: (params) => addBenefits(params) });
};
